import queryString from 'query-string'
import { HniAuthenticationApi, HniAuthApiWithProgress } from './factoryApi';
import sharedAccountsApi from './sharedAccountsApi';

const instance = HniAuthenticationApi();
const instanceWithProgress = HniAuthApiWithProgress();


const authenticate = async (ssoToken) => {
	if (!ssoToken) {
		//TODO: error handling
		return;
	}

	var promise =  instance.post('/api/token',
		queryString.stringify({
			username: ssoToken,
			password: 'HON',
			grant_type: 'password',
			client_id: 40
		}), {
			headers: {
				"Content-Type": "application/x-www-form-urlencoded"
			}
		}
	)
	.then(response => {
		if (response.data.access_token) {
			localStorage.setItem('api.tokenKey', response.data.access_token);
		}
		
		return true;
	})
	.catch(error => {
		//TODO: do something with the returned error; redirect? toast?
		console.log(error);
		localStorage.removeItem('api.tokenKey');
		return false;
	});

	return promise;
};


const userAuth = async () => {
	var promise = instanceWithProgress.get('/api/userauth')
	.then(response => {
		if (response.data) {
			var userInfo = response.data;
	
			localStorage.setItem('user.FirstName', userInfo.FirstName);
			localStorage.setItem('user.LastName', userInfo.LastName);
			localStorage.setItem('user.Email', userInfo.Email);
			localStorage.setItem('user.UserID', userInfo.UserID);
			localStorage.setItem('user.Division', userInfo.Division);
			 
			sharedAccountsApi.getUserInfo(userInfo.UserID)
				.then(async userInfo2 => {
					localStorage.setItem('user.DxpGuid', userInfo2.DxpGuid);
				})
				.catch(error => {
					this.handleError(error);
				});
		}

		return true;
	})
	.catch(error => {
		//TODO: do something with the returned error; redirect? toast?
		console.log(error);
		return false;
	});

	return promise;
};


const permissions = async () => {
	var promise = instanceWithProgress.get('/api/permissions')
	.then(response => {
		if (response.data) {
			var permissions = response.data;
	
			localStorage.setItem('user.IsAdmin', permissions.some(x => x === "Admin"));
			localStorage.setItem('user.CanView', permissions.some(x => x === "CanView"));
			localStorage.setItem('user.CanSubmit', permissions.some(x => x === "CanSubmit"));
		}

		return true;
	})
	.catch(error => {
		//TODO: do something with the returned error; redirect? toast?
		console.log(error);
		return false;
	});

	return promise;
};


export default {
	authenticate,
	userAuth,
	permissions
};